import { Drawer } from "antd";

import { logEvent } from "firebase/analytics";
import { analytics } from "../../firebase";
import PropTypes from "prop-types";

export const CustomDrawer = ({
  open,
  onClose,
  title,
  children,
  width = 480,
  placement = "right",
  analyticsData = {},
}) => {
  const handleClose = () => {
    if (analyticsData.mail) {
      logEvent(analytics, "drawer_closed", {
        drawerTitle: title,
        ...analyticsData,
      });
    }
    onClose();
  };

  return (
    <Drawer
      title={
        <div className="custom-drawer-header">
          <span className="custom-drawer-title">{title}</span>
          <button type="button" className="custom-drawer-close" onClick={handleClose}>
            ✕
          </button>
        </div>
      }
      placement={placement}
      onClose={handleClose}
      open={open}
      width={width}
      destroyOnClose
      maskClosable={true}
      closable={false}
      className="custom-drawer"
    >
      <div className="custom-drawer-content">{children}</div>
    </Drawer>
  );
};

CustomDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  width: PropTypes.number,
  placement: PropTypes.oneOf(["left", "right", "top", "bottom"]),
  analyticsData: PropTypes.object,
};
